export enum SymbolLegendIconVariation {
  Shutters = 'shutters',
  Vents = 'vents',
}
